import React from 'react';
import { Control } from 'react-hook-form';
import { ControllerWrapper } from '../../../../../../hooks/providers/ControllerWrapper';
import { InviteFlowFields } from '../../../../consts';
import { LiliTextInput } from '../../../../../../DesignSystem/LiliTextInput/LiliTextInput';
import { InviteFormType } from '../../InviteFormStep';
import { removeWhiteSpacesFromString } from '../../../../../../services/general.service';

interface FirstNameInputProps {
  control: Control<InviteFormType, any>;
}

export const LastNameInput = ({ control }: FirstNameInputProps) => (
  <ControllerWrapper name={InviteFlowFields.LAST_NAME} control={control}>
    {({ onBlur, onChange, error, value }) => (
      <LiliTextInput
        onChange={(v) => onChange(removeWhiteSpacesFromString(v))}
        value={value}
        onBlur={onBlur}
        id={InviteFlowFields.LAST_NAME}
        title='Last Name'
        errorMessage={error?.message}
      />
    )}
  </ControllerWrapper>
);
